import { render, staticRenderFns } from "./EvolutionForm.vue?vue&type=template&id=2f07fa55&scoped=true"
import script from "./EvolutionForm.vue?vue&type=script&lang=js"
export * from "./EvolutionForm.vue?vue&type=script&lang=js"
import style0 from "./EvolutionForm.vue?vue&type=style&index=0&id=2f07fa55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07fa55",
  null
  
)

export default component.exports